@active-tab: #253a4f;
@active-tab__shadow: rgba(111, 111, 111, 0.25);
@price-down: @ig-red;
@price-up: @ig-blue;

section {
  max-width: 1120px;
  padding-right: 15px;
  padding-left: 15px;
  margin: 0 auto 3rem;

  .row {
    display: flex;
    flex-wrap: wrap;
    margin-right: -15px;
    margin-left: -15px;
  }

  .col-sm {
    flex-basis: 0;
    flex-grow: 1;
    max-width: 100%;
    position: relative;
    width: 100%;
    padding-right: 15px;
    padding-left: 15px;
  }

  .colMinWidth {
    min-width: 200px;
  }

  .red,
  h4.red { //increase specificity
    color: @price-down;
  }

  .btn-group {
    margin-bottom: 10px;
    position: relative;
    display: inline-flex;
    vertical-align: middle;
    width: 100%;
  }

  .btn {
    .MatterRegular();
    min-width: 80px;
    cursor: pointer;
    display: inline-block;
    text-align: center;
    vertical-align: middle;
    padding: 6px 12px;
    border-radius: 4px;
    line-height: 1.5;
    border: 1px solid transparent;
    user-select: none;
    transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out,
                border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
    position: relative;
    flex: 1 1 auto;
  }

  .btn.focus,
  .btn:focus {
    outline: 0;
    box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25);
  }

  .btn-primary {
    .MatterSemiBold();
    border: 1px solid @ig-blue-700;
    font-size: 18px;
    padding-left: 20px;
    padding-right: 20px;
    background-color: @ig-green;
    border-color: @ig-green;
    color: @white;

    &:hover {
      border-color: @ig-green-600;
      background-color: @ig-green-600;
    }
  }

  .btn-outline-info:not(:disabled):not(.disabled).active,
  .btn-outline-info:not(:disabled):not(.disabled):active,
  .show > .btn-outline-info.dropdown-toggle {
    color: @white;
    background-color: @active-tab;
    border-color: @ig-blue-900;
    box-shadow: 4px 0px 4px @active-tab__shadow;
  }

  .btn-group > .btn-group:not(:first-child) > .btn,
  .btn-group > .btn:not(:first-child) {
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
  }

  .btn-group > .btn-group:not(:last-child) > .btn,
  .btn-group > .btn:not(:last-child):not(.dropdown-toggle) {
    border-top-right-radius: 0;
    border-bottom-right-radius: 0;
  }

  .btn-group > .btn-group:not(:first-child),
  .btn-group > .btn:not(:first-child) {
    margin-left: -1px;
  }

  .btn-group-toggle > .btn input[type='radio'],
  .btn-group-toggle > .btn-group > .btn input[type='radio'] {
    position: absolute;
    clip: rect(0, 0, 0, 0);
    pointer-events: none;
  }

  .btn-outline-info {
    color: @active-tab;
    border-color: @ig-blue-900;

    &:hover {
      color: @white;
      background-color: @active-tab;
      border-color: @ig-blue-900;
    }

    &:not(:disabled):not(.disabled).active:focus,
    &:not(:disabled):not(.disabled):active:focus {
      box-shadow: 0 0 0 0.2rem rgba(23, 162, 184, 0.5);
    }
  }

  .btn-group > .btn.active,
  .btn-group > .btn:active,
  .btn-group > .btn:focus {
    z-index: 1;
  }

  .btn.active small,
  .btn:hover small {
    color: @white;
  }

  .bd-placeholder-img {
    font-size: 1.125rem;
    text-anchor: middle;
    user-select: none;
  }

  .btn-group .btn {
    cursor: pointer;
    font-size: 16px;
    padding: 15px 8px;
  }

  .table {
    width: 100%;
    color: #212529;
    border-collapse: collapse;
    th {
      text-align: left;
    }
    thead th {
      vertical-align: bottom;
      border-bottom: 2px solid @ig-grey-300;
      background: @ig-grey-100;
    }
    thead th,
    td {
      vertical-align: top;
      table-layout: fixed;
      padding: 0.75rem;
      vertical-align: top;
      border-top: 1px solid @ig-grey-300;
    }
    tbody th {
      width: 30%;
      vertical-align: top;
      padding: 0.9rem 0.75rem;
    }

    tr {
      border-bottom: 1px solid @ig-grey-300;
    }

    tbody h4 {
      .MatterMedium();
      font-size: 26px;
      margin-bottom: 5px;
      margin-top: 0;
    }
  }

  h6 {
    .MatterMedium();
    margin-bottom: 0.5rem;
    margin-top: 0;
    line-height: 1.2;
    font-size: 1rem;
  }

  .blue {
    color: @price-up;
  }

  small {
    .MatterRegular();
    font-size: 13px;
    line-height: 1.5;
    display: block;
    color: @ig-grey-800;

    .tooltip-trigger {
      margin-left: 0;
      color: @price-up;
    }
  }

  .hide {
    display: none;
  }

  .pricing-header {
    text-align: center;
    padding: 3rem 0 1.5rem 0;
  }

  .lead {
    .MatterLight();
    font-size: 1.25rem;
  }

  .badge {
    .MatterBold();
    display: inline-block;
    padding: 0.25em 0.4em;
    font-size: 75%;
    line-height: 1;
    text-align: center;
    white-space: nowrap;
    vertical-align: baseline;
    border-radius: 0.25rem;
    transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out,
      border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
  }

  .badge-danger {
    color: @white;
    background-color: @price-down;
  }

  .tooltip-trigger {
    cursor: pointer;
    border-bottom: @ig-grey-400 dashed 1px;
    margin-bottom: 3px;
    position: relative;
    margin-left: 10px;

    .tooltip-content {
      .MatterRegular();
      display: none;
      background-color: @active-tab;
      color: @white;
      padding: 5px 10px;
      font-size: 13px;
      line-height: 1.5;
      width: 175px;
      position: absolute;
      text-align: left;
      left: -12px;
      border-radius: 5px;
      margin-top: 10px;
      z-index: 20;

      &:before {
        top: 0;
        left: 10px;
        border: solid transparent;
        content: '';
        height: 0;
        width: 0;
        position: absolute;
        pointer-events: none;
        border-top-color: @active-tab;
        border-width: 10px;
        margin-top: -18px;
        transform: rotate(180deg);
      }
    }

    &:hover .tooltip-content {
      display: block;
    }

    &.tooltip-red {
      border-bottom-color: @ig-red-200;
    }
  }

  .tooltip-icon {
    text-indent: -1000px;
    display: inline-block;
    width: 15px;
    height: 15px;
    background: @tooltip-icon no-repeat;
  }

}
